module.exports = __webpack_public_path__ + "static/media/4931-11.b0eed374.jpg";